/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isBooleanType
 */

export default function isBooleanType(value) {
  return typeof value === 'boolean';
}
